import { LoginButton, LoginTitleField, InputFormLabel, LoginButtonField, InputFormField, InputIndividualField, Footer, Header } from './activation.style';
import React from 'react';
import SwalUtil from '../../shared/util/sweetalert/sweetalertUtil';
import { Success, AuthFail, AccountLock, SystemErrorTitle, SystemErrorMsg } from '../../constants'
import { useNavigate } from "react-router-dom";
import certificationActivation from '../../shared/api/certificationActivation';
import { BackdropLoading } from '../../shared/spinner/backdropLoading';
import "./style.css"

interface errProp {
    err: boolean;
}
const Activation: React.FC<errProp> = ({ err }) => {

    const [contractId, setContractId] = React.useState("");
    const [contractPass, setPassword] = React.useState("");
    const [loading, setLoading] = React.useState<boolean>(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        (async () => {
            if (err) {
                // エラー画面遷移
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg, isLogin: false } });
            }
        })()
    }, []);

    // ログイン押下
    const onSubmit = async () => {

        if (!contractId || !contractPass) {
            SwalUtil.labelInfo({
                title: "入力エラー",
                message: "契約者コードまたは、契約パスワードを<br/>入力してください",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else if (contractId.length != 15 || contractPass.length != 20) {
            SwalUtil.labelInfo({
                title: "入力エラー",
                message: "契約者コードまたは、契約パスワードの<br/>桁数が不正です",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else if (!contractId.match(/^[A-Za-z0-9]*$/) || !contractPass.match(/^[A-Za-z0-9]*$/)) {
            SwalUtil.labelInfo({
                title: "入力エラー",
                message: "契約者コードまたは、契約パスワードの<br/>形式が不正です",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else {
            // Postリクエスト送信
            setLoading(true)
            const response = await certificationActivation(contractId, contractPass)

            // レスポンスを確認する
            setLoading(false)
            if (response.resCd == Success) {
                // ローカルストレージに保存
                localStorage.setItem('contractId', response.data.contractId)
                window.location.reload();

            } else if (response.resCd == AuthFail) {
                SwalUtil.labelInfo({
                    title: "認証失敗エラー",
                    message: "契約者コードまたは、契約パスワードが違います",
                    icon: "error",
                    confirmButtonText: "OK",
                    buttonAlign: "right",
                });

            } else if (response.resCd == AccountLock) {
                let unlockDate = response.data.unlockDate
                SwalUtil.labelInfo({
                    title: "アカウントロックエラー",
                    message: "アカウントがロックされています。<br/>しばらく待ってからやり直してください。<br/>解除予定日時：" + unlockDate,
                    icon: "error",
                    confirmButtonText: "OK",
                    buttonAlign: "right",
                });
            } else {
                // エラー画面遷移
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg, isLogin: false } });
            }
        }
    }

    return (
        <><Header>
            <img src={`${process.env.PUBLIC_URL}/symbol-color-min.jpg`} width="50px" alt="株式会社東京商工リサーチ" title="東京商工リサーチ" />
        </Header>
            <BackdropLoading open={loading} />
            <dialog open className='dialog'>
                <LoginTitleField>利用開始手続き</LoginTitleField>
                <InputFormField>
                    <InputIndividualField>
                        <InputFormLabel>契約者コード　</InputFormLabel>
                        <input
                            type="text"
                            size={40}
                            onChange={(e) => setContractId(e.target.value)}
                        />
                    </InputIndividualField>
                    <InputIndividualField>
                        <InputFormLabel>契約パスワード</InputFormLabel>
                        <input
                            type="password"
                            size={40}
                            name="contractPass"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </InputIndividualField>
                </InputFormField>
                <LoginButtonField>
                    <LoginButton type="submit" onClick={() => onSubmit()}>
                        利用開始
                    </LoginButton>
                </LoginButtonField>
            </dialog>
            <Footer>
                &copy; TOKYO SHOKO RESEARCH, LTD.
            </Footer></>
    );
}

export default Activation;
